import { Country, State } from "country-state-city";

export const getStatesByCountryName = (countryName) => {
  if (!countryName) return [];
  const selectedName = typeof countryName === "object" && countryName?.label
    ? countryName?.label
    : String(countryName);

  const countries = Country.getAllCountries().find(
    (country) => country?.name?.toLowerCase() === selectedName?.toLowerCase()
  );

  return countries ? State.getStatesOfCountry(countries.isoCode) : [];
};
